(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const redirectInput = document.getElementById('redirect_product_title');
  if (!redirectInput) return;

  let url = window.location.href;
  let urlParts = url.split('?product=');

  if(urlParts.length > 1) {
    let productTitle = decodeURIComponent(urlParts[1].replace(/\+/g, ' '));

    if(redirectInput) {
      redirectInput.value = productTitle;
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minicart"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".js-minicart-product-recommendations");
    if (section) {
      getProductRecommendations(section);
    }
  });

  function getProductRecommendations(section) {
    const url = section.dataset.url;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          ".js-minicart-product-recommendations"
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          section.innerHTML = recommendations.innerHTML;
        }
      })
      .then(() => {
        initProductRecommendationsSwiper(section);
        initMinicartRecommendedProductsSelectors(section);
        section.classList.remove("hidden");
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function initProductRecommendationsSwiper(section) {
    const ProductRecommendationsSwiper = section.querySelector(
      ".product-recommendations-swiper"
    );
    if (!ProductRecommendationsSwiper) return;
    window.Moonbase.initSwiper(ProductRecommendationsSwiper);
  }

  document.addEventListener("liquid-ajax-cart:request-end", function(event) {
    const {requestState, cart, previousCart, sections} = event.detail;
    const section = document.querySelector(".js-minicart-product-recommendations");

    if (requestState.requestType === 'add' && section) {
       getProductRecommendations(section);
    }
  });

 function initMinicartRecommendedProductsSelectors(section) {
    const slides = section.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {
      const selects = slide.querySelectorAll('select');
      selects.forEach(select => {
        select.addEventListener('change', function() {
          const form = slide.querySelector('.minicart-recommended-products-form');
          const variantsJson = form.getAttribute('data-variants');
          const variants = JSON.parse(variantsJson);
          const selectedOptions = Array.from(selects).map(select => select.value);
          const variantIdInput = form.querySelector('[name="id"]');
          const matchingVariant = variants.find(variant => {
            return variant.options.every((opt, index) => opt === selectedOptions[index]);
          });

          if (matchingVariant) {
            variantIdInput.value = matchingVariant.id;
          }
        });
      });
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  function getRecentlyViewedProducts() {
    const productData = JSON.parse(localStorage.getItem("recentlyViewedProducts"));
    const fullContent = document.querySelector(".recently-viewed-grid");
    const recentlyViewedSection = document.querySelector(".recently-viewed-section");
    const productCardTemplate = document.querySelector("#product-card");
    const recentlyViewedHtml = [];

    // Get the last 8 products
    const latestViewedProducts = productData?.slice(-9) || [];

    // Remove duplicates based on product handle
    const uniqueProducts = [];
    const seenHandles = new Set();

    latestViewedProducts.forEach(product => {
      if (!seenHandles.has(product.handle)) {
        seenHandles.add(product.handle);
        uniqueProducts.push(product);
      }
    });

    const productDataFiltered = uniqueProducts.filter(product => {
      return product.id !== window.Moonbase.productJson.id;
    });

    console.log(productDataFiltered.length);

    if (productDataFiltered.length > 2) {
      Promise.all(productDataFiltered.map(item => {
        return fetch(`${window.Shopify.routes.root}products/${item.handle}`)
          .then(response => {
            if (!response.ok) {
              // Product page doesn't exist (e.g., 404)
              console.warn(`Product not found: ${item.handle}`);
              return null;
            }
            return response.text();
          })
          .then(html => {
            if (!html) return;
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const productCard = doc.querySelector('#product-card');
            if (productCard) {
              const newSlide = document.createElement("div");
              newSlide.classList.add("swiper-slide", "!h-auto");
              newSlide.innerHTML = productCard.innerHTML;
              recentlyViewedHtml.push(newSlide);
            }
          })
          .catch(error => {
            console.error('Error fetching product card:', error);
          });
      }))
      .then(() => {
        fullContent.innerHTML = "";
        recentlyViewedHtml.forEach(item => {
          if (fullContent) {
            fullContent.appendChild(item);
          }
        });
        const swiperEl = document.querySelector(".recently-viewed-swiper");
        if (!swiperEl) return;
        window.Moonbase.initSwiper(swiperEl);
      })
      .catch(error => {
        console.error('Error fetching product cards:', error);
      });
    } else {
      recentlyViewedSection.classList.add('!hidden');
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    getRecentlyViewedProducts();
  });

  } catch(e) { console.error(e); }
})();
})();
